import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://56e10c5963434732bc1e55b2c5e6e367@o1246955.ingest.us.sentry.io/4509126497665024',
  integrations: [Sentry.browserTracingIntegration()],
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/]
})
